module.exports = __webpack_public_path__ + "static/form-button-feedback-do-5b8a8765d8834c61f8f1c706abb98372.png";